/**
 * Parallax maths for the yard's background (ui/nest.ts).
 *
 * The scene tiles each layer sideways from the nest and mirrors every other
 * copy, so neighbouring tiles always meet edge to edge whatever the art does
 * and no layer has to be drawn as a seamless loop. The cost is that the
 * repeating pattern is **two** tiles wide rather than one, which is the whole
 * reason this is a function and not a modulo at the call site.
 */

/**
 * How far a drifting layer has moved, wrapped so the shift stays small however
 * long a session runs.
 *
 * Wrapping at a single tile is the obvious thing and it is wrong: the tiler
 * decides which copies to mirror from the tile index, so a jump of exactly one
 * tile flips the parity of every copy and the whole layer mirror-flips in one
 * frame. Wrapping at two leaves the parity where it was.
 */
export function driftShift(pxPerSecond: number, seconds: number, tileWidth: number): number {
  if (!(tileWidth > 0)) return 0;
  const period = tileWidth * 2;
  // The doubled modulo keeps a negative rate — a layer drifting the other
  // way — inside the period as well.
  return (((pxPerSecond * seconds) % period) + period) % period;
}
